































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { CondicionComercial } from "@/typings/store/plugins/easyFirestore/condicionesComerciales";
import { ItemsTablaCondicionesComerciales } from "@/typings/components/condicionesComerciales/tabla";
import "@/helpers/extensions";
import { CondicionDivision } from "@/typings/store/plugins/easyFirestore/condicionesDivisiones";
import { aFecha } from "@/helpers/fechas";

@Component
export default class TablaUsuarios extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly condicionesComerciales!: Array<CondicionComercial>;
  @Prop() readonly condicionDivision!: CondicionDivision;
  @Prop({ default: () => [] }) readonly condicionesDivisiones!: Array<CondicionDivision>;

  /** Divisiones de una condición (los códigos pueden estar guardados como número o texto). */
  divisionesDe(condicion: CondicionComercial): Array<CondicionDivision> {
    return this.condicionesDivisiones.filter(
      (d) =>
        String(d.codigo_contrato) === String(condicion.codigo_contrato) &&
        String(d.codigo_condicion) === String(condicion.codigo_condicion)
    );
  }

  get items(): ItemsTablaCondicionesComerciales {
    const fecha = (v: unknown) => aFecha(v)?.toLocaleDateString("es-CL") ?? "";
    return this.condicionesComerciales.map((condicionComercial) => {
      const codigo_condicion = condicionComercial.codigo_condicion;
      const desde = fecha(condicionComercial.desde);
      const hasta = fecha(condicionComercial.hasta);
      const liquidacion = condicionComercial.liquidacion;

      return {
        codigo_condicion,
        desde,
        hasta,
        liquidacion,

        data: condicionComercial,
      };
    });
  }

  @Emit("abrir-info")
  onAbrirInfo(condicionComercial: CondicionComercial): CondicionComercial {
    return condicionComercial;
  }

  @Emit("abrir-editar")
  onAbrirEditar(condicionComercial: CondicionComercial): CondicionComercial {
    return condicionComercial;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(condicionComercial: CondicionComercial): CondicionComercial {
    return condicionComercial;
  }

  // @Emit("abrir-editar-division")
  // onAbrirEditarDivision(condicionDivision: CondicionDivision): CondicionDivision {
  //   return condicionDivision;
  // }
}
